import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-nocheck
import React from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { Grid, Typography, ErrorHandling, CircularProgress } from "../../mui";
import { ContentTypography } from "../../common/content";
import { ContentToPDF } from "../../common/content";
import { capitalizeSentence } from "../../../utils/common";
import { UserPermission, FeatureType } from "../../../utils/enums";
const INVOICE_PREVIEW = gql `
  query InvoicePreviewQuery($id: ID!) {
    invoice(id: $id) {
      id
      createdAt
      updatedAt
      name
      amountDue
      accountOwner {
        id
        firstName
        lastName
        email
      }
      client {
        id
        name
        pool {
          id
          address {
            id
            streetNumber
            streetName
            city
            state
            country
            postalCode
          }
        }
      }
    }
    currentOrganization {
      id
      name
      address {
        id
        streetNumber
        streetName
        city
        state
        country
        postalCode
      }
    }
  }
`;
const InvoicePreview = ({ id = null, permissions = [] }) => {
    const [getInvoice, { loading, error, data }] = useLazyQuery(INVOICE_PREVIEW);
    React.useEffect(() => {
        if (id) {
            getInvoice({
                variables: {
                    id,
                },
            });
        }
    }, [id]);
    if (loading)
        return (_jsx(Grid, { container: true, alignItems: "center", justifyContent: "center", children: _jsx(Grid, { item: true, sx: { marginTop: "20%" }, children: _jsx(CircularProgress, { size: 40, color: "primary" }) }) }));
    if (error)
        return _jsx(ErrorHandling, { error: error });
    const downloadActionPermitted = permissions?.find((permission) => permission?.feature === FeatureType.DownloadContent)?.permission ===
        UserPermission.Manage;
    return (_jsxs(_Fragment, { children: [_jsx(Grid, { container: true, children: _jsx(Grid, { item: true, xs: 12, children: _jsx(ContentTypography, { color: "primary", variant: "subtitle2", field: "invoicePreviewLabel" }) }) }), _jsx(ContentToPDF, { disabled: !downloadActionPermitted, children: _jsxs(Grid, { container: true, spacing: 2, sx: { m: 8, maxWidth: "100vh" }, direction: "row", children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(Typography, { variant: "h5", children: data?.invoice?.name || "–" }) }), _jsxs(Grid, { item: true, xs: 12, children: [_jsxs(Grid, { container: true, spacing: 4, children: [_jsx(Grid, { item: true, xs: 3, children: _jsx(Typography, { children: "Billed To:" }) }), _jsxs(Grid, { item: true, xs: 9, children: [_jsx(Typography, { children: data?.invoice?.client?.name || "–" }), data?.invoice?.client?.pool?.address ? (_jsxs(_Fragment, { children: [_jsx(Typography, { children: `${data?.invoice?.client?.pool?.address?.streetNumber} ${data?.invoice?.client?.pool?.address?.streetName}` ||
                                                                "–" }), _jsx(Typography, { children: `${data?.invoice?.client?.pool?.address?.city}, ${data?.invoice?.client?.pool?.address?.state} ${data?.invoice?.client?.pool?.address?.postalCode}` ||
                                                                "–" })] })) : ("–")] })] }), _jsx("br", {}), _jsxs(Grid, { container: true, spacing: 4, children: [_jsx(Grid, { item: true, xs: 3, children: _jsx(ContentTypography, { field: "payToLabel", children: ":" }) }), _jsxs(Grid, { item: true, xs: 9, children: [_jsx(Typography, { children: capitalizeSentence?.(data?.currentOrganization?.name) || "–" }), _jsx(Typography, { children: `${data?.currentOrganization?.address?.streetNumber || ""} ${data?.currentOrganization?.address?.streetName || "–"}` }), data?.currentOrganization?.address && (_jsx(Typography, { children: `${data?.currentOrganization?.address?.city || "–"}, ${data?.currentOrganization?.address?.state || "–"} ${data?.currentOrganization?.address?.postalCode || ""}` }))] })] }), data?.invoice?.inventories?.length > 0 && (_jsxs(Grid, { container: true, spacing: 4, sx: { mt: 8 }, children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(ContentTypography, { field: "inventoriesLabel", children: ":" }) }), data?.invoice?.inventories?.map((inventory, index) => (_jsxs(Grid, { item: true, xs: 12, sx: { m: 1 }, children: [_jsxs(Typography, { children: ["Name: ", inventory?.name || "–"] }), inventory?.quantity && _jsxs(Typography, { children: ["Quantity: ", inventory?.quantity] }), inventory?.amount && _jsxs(Typography, { children: ["Price: $", inventory?.amount] })] }, index))), _jsx(Grid, { item: true, xs: 12, children: _jsxs(ContentTypography, { field: "invoiceAmountLabel", children: [": $", data?.invoice?.amountDue || "–"] }) })] }))] }), _jsx(Grid, { item: true, xs: 12, children: _jsx(Grid, { container: true, justifyContent: "flex-end", alignItems: "flex-end", children: _jsxs(Grid, { item: true, children: [_jsx(ContentTypography, { field: "reachOutMessageLabel", children: ":" }), _jsxs(Typography, { children: [data?.invoice?.accountOwner?.firstName || "–", " ", data?.invoice?.accountOwner?.lastName] }), _jsx(Typography, { children: data?.invoice?.accountOwner?.email || "–" })] }) }) })] }) })] }));
};
export default InvoicePreview;
